module.exports = __webpack_public_path__ + "img/zk-icon-store.f31be0c8.svg";